export const parseJwt = (token) => {
  try {
    if (!token || typeof token !== 'string' || token.split('.').length < 2) {
      return null;
    }

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};

export const isTokenExpired = (token) => {
  if (!token) return true;

  const decoded = parseJwt(token);
  if (!decoded?.exp) return true;

  return decoded.exp < Math.floor(Date.now() / 1000);
};

export const getTokenExpirationTime = (token) => {
  if (!token) return 0;

  const decoded = parseJwt(token);
  if (!decoded?.exp) return 0;

  const expiresIn = decoded.exp - Math.floor(Date.now() / 1000);
  return expiresIn > 0 ? expiresIn * 1000 : 0;
};